import React, {Component} from 'react';

class Constants extends React.Component {

    static get apiUrl() { return "https://app2.ecardio.com.br"; }

    // static get apiUrl() { return "http://localhost:8080"; }
    static get clientId() { return "webclient2"; }
    static get clientSecret() { return ""; }

    static get ignoreNotifications(){ return false; }

    //ENUMS
    static get status() {
      return {
        'EXAM_STATUS_CREATED' : {
            'text': 'Criado',
            'class': 'default'
        },
        'EXAM_STATUS_CREATED_LOCAL' : {
            'text': 'Aguardando Laudo Local',
            'class': 'default'
        },
        'EXAM_STATUS_SENT_TO_REPORT' : {
            'text': 'Enviado',
            'class': 'info'
        },
        'EXAM_STATUS_WAITING_REPORT' : {
            'text': 'Aguardando Laudo',
            'class': 'warning'
        },
        'EXAM_STATUS_REPORTED' : {
            'text': 'Laudado',
            'class': 'success'
        }
      };
    }

    static get priority() {
      return {
        'PRIORITY_LOW' : 'Eletivo',
        'PRIORITY_NORMAL' : 'Normal',
        'PRIORITY_HIGH' : 'Urgente',
        'PRIORITY_URGENCY' : 'Emerência'
      };
    }

    static get patient_doctype() {
      return {
        'PATIENT_DOC_CPF' : 'CPF',
      	'PATIENT_DOC_RG' : 'RG',
      	'PATIENT_DOC_SUS' : 'CARTAO SUS',
      	'PATIENT_DOC_PP' : 'PASSAPORTE',
      	'PATIENT_DOC_OUTROS' : 'OUTROS DOCUMENTOS',
      	'PATIENT_DOC_NO_ID' : 'SEM DOCUMENTO',
      	'PATIENT_DOC_EXT' : 'EXTERNO'
      };
    }

    render(){
        return null
    }
}

export default Constants;



// WEBPACK FOOTER //
// ./src/components/Constants/Constants.js